const brandList = [
  {
    name: "apple",
    image:
      "https://res.cloudinary.com/de5it79dw/image/upload/v1648494496/a-removebg-preview_n9pgdn.png",
  },
  {
    name: "samsung",
    image:
      "https://res.cloudinary.com/de5it79dw/image/upload/v1648491317/samsung_tcokhr.png",
  },
  {
    name: "oneplus",
    image:
      "https://res.cloudinary.com/de5it79dw/image/upload/v1648491345/oneplus_ziu18z.png",
  },
  {
    name: "hp",
    image:
      "https://res.cloudinary.com/de5it79dw/image/upload/v1649217725/png-clipart-hewlett-packard-laptop-hp-pavilion-microsoft-organization-copywriter-floor-blue-company-removebg-preview_kfdvp6.png",
  },
  {
    name: "fasttrack",
    image:
      "https://res.cloudinary.com/de5it79dw/image/upload/v1649217822/d6f2d0a925912bdd5287af0da5143e79-removebg-preview_z6efuv.png",
  },
  {
    name: "boat",
    image:
      "https://res.cloudinary.com/de5it79dw/image/upload/v1649218140/unnamed-removebg-preview_mzn1pd.png",
  },
];
export { brandList };
